import { render } from "./MdDialogActions.vue?vue&type=template&id=41010038"
import script from "./MdDialogActions.vue?vue&type=script&lang=js"
export * from "./MdDialogActions.vue?vue&type=script&lang=js"

import "./MdDialogActions.vue?vue&type=style&index=0&id=41010038&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__